import React, { Fragment, useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import tools from "../../components/tools/tools";
import Loader from '../common/loader';
import './assets/css/estadisticasrep.css';
/* import { Bar, Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend); */
/* import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend); */

import { PolarArea, Line } from 'react-chartjs-2';
import { Chart as ChartJS, RadialLinearScale, ArcElement, Tooltip, Legend, LineElement,
    PointElement,
    LinearScale,
    CategoryScale, } from 'chart.js';

ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend, 
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,);

// Define your specific carnet types here (should be consistent with estadistica.js)
const PREDEFINED_CARNET_TYPES = [
    { value: '1', label: 'Asistente', clave: '1' },
    { value: '3', label: 'Expositor', clave: '3' },       
    { value: '4', label: 'Invitado Especial', clave: '4' },
    { value: '6', label: 'Staff', clave: '6' },
    { value: '11', label: 'Ponente', clave: '11' },   
    // { value: '19', label: 'Socio', clave: '19' } 
];

const EstadisticaReproduccion = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [carnetLabelForDisplay, setCarnetLabelForDisplay] = useState('CARGANDO...');
    const [statisticsData, setStatisticsData] = useState({
        totalAttendees: '-', printedCount: '-', remainingToPrint: '-',
    });
    const [loading, setLoading] = useState(true);
    const [playbackIntervalId, setPlaybackIntervalId] = useState(null);
    
    const [initialFilters, setInitialFilters] = useState(null);
    
    const [allCarnetTypesMap, setAllCarnetTypesMap] = useState(new Map()); 

    const [progressPercentage, setProgressPercentage] = useState(100);
    const [progressIntervalId, setProgressIntervalId] = useState(null);
    const [currentDisplayMode, setCurrentDisplayMode] = useState('full'); 

    useEffect(() => {
        if (location.state && 
            location.state.selectedCarnetType !== undefined && 
            location.state.paymentStatuses &&
            location.state.displayMode) {
            setInitialFilters({
                selectedCarnetType: location.state.selectedCarnetType,
                paymentStatuses: location.state.paymentStatuses,
                formatoAsistencia: location.state.formatoAsistencia || [1, 2],
            });
            setCurrentDisplayMode(location.state.displayMode);
        } else {
            tools.notie.alert({ type: 'error', text: 'Filtros o modo de visualización no proporcionados para reproducción.', time: 3 });
            navigate('/mesaregistro/estadistica');
        }
    }, [location.state, navigate]);

    useEffect(() => {
        async function fetchAndPrepareCarnetTypes() {
            if (!initialFilters) return;
            setLoading(true);
            try {
                const response = await fetch('/rt_carnets_activos', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' }
                });
                const data = await response.json();
                const newCarnetTypesMapInternal = new Map();

                if (data.status === 1 && data.carnets) {
                    const activeApiValues = new Set(data.carnets.map(c => c.VALOR_TPO.toString()));
                    
                    PREDEFINED_CARNET_TYPES.forEach(predefinedType => {
                        if (activeApiValues.has(predefinedType.value)) {
                            newCarnetTypesMapInternal.set(predefinedType.value, predefinedType.label);
                        }
                    });
                    setAllCarnetTypesMap(newCarnetTypesMapInternal);

                    if (initialFilters.selectedCarnetType !== '') {
                        const label = newCarnetTypesMapInternal.get(initialFilters.selectedCarnetType) || 
                                      (PREDEFINED_CARNET_TYPES.find(p => p.value === initialFilters.selectedCarnetType)?.label || `TIPO ${initialFilters.selectedCarnetType}`);
                        setCarnetLabelForDisplay(label.toUpperCase());
                    } else if (newCarnetTypesMapInternal.size === 0) {
                         setCarnetLabelForDisplay("NO HAY TIPOS DE CARNET ACTIVOS");
                    }
                } else {
                    tools.notie.alert({ type: 'warning', text: 'No se pudieron cargar los tipos de carnet activos.', time: 3 });
                    setCarnetLabelForDisplay("ERROR CARGANDO TIPOS");
                }
            } catch (error) {
                tools.notie.alert({ type: 'error', text: 'Error crítico cargando tipos de carnet.', time: 3 });
                setCarnetLabelForDisplay("ERROR CRÍTICO");
            } finally {
                if (allCarnetTypesMap.size === 0 && initialFilters && initialFilters.selectedCarnetType === '') setLoading(false);
            }
        }
        fetchAndPrepareCarnetTypes();
    }, [initialFilters]);


    const fetchStatsForDisplay = async (carnetTypeToFetch, paymentStatusesToUse, labelForThisFetch) => {
        setLoading(true);
        if (labelForThisFetch) {
            setCarnetLabelForDisplay(labelForThisFetch.toUpperCase());
        }
        try {
            const response = await fetch('/rt_obtener_estadisticas', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    selectedCarnetType: carnetTypeToFetch, 
                    paymentStatuses: paymentStatusesToUse,
                    formatoAsistencia: initialFilters.formatoAsistencia
                })
            });
            const result = await response.json();
            if (result.status === 1 && result.data) {
                setStatisticsData(result.data);
            } else {
                setStatisticsData({ totalAttendees: 'E', printedCount: 'E', remainingToPrint: 'E' });
            }
        } catch (error) {
            setStatisticsData({ totalAttendees: 'X', printedCount: 'X', remainingToPrint: 'X' });
        } finally {
            setLoading(false);
        }
    };

    const handleReturnAndStop = () => {
        if (playbackIntervalId) clearInterval(playbackIntervalId);
        if (progressIntervalId) clearInterval(progressIntervalId);
        navigate('/mesaregistro/estadistica');
    };
    
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                handleReturnAndStop();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [playbackIntervalId, progressIntervalId, navigate]); // Add dependencies that handleReturnAndStop uses

    useEffect(() => {
        if (!initialFilters || (initialFilters.selectedCarnetType === '' && allCarnetTypesMap.size === 0 && !loading) ) {
             if (initialFilters && initialFilters.selectedCarnetType === '' && allCarnetTypesMap.size === 0 && !loading) {
                setCarnetLabelForDisplay("NO HAY TIPOS PARA CICLAR");
                setStatisticsData({ totalAttendees: '-', printedCount: '-', remainingToPrint: '-' });
             }
            return;
        }
        
        if (initialFilters.selectedCarnetType === '' && allCarnetTypesMap.size === 0) {
            return; 
        }

        let currentIndex = 0;
        const carnetValuesForCycling = Array.from(allCarnetTypesMap.keys());

        const startProgressCountdown = () => {
            if (progressIntervalId) clearInterval(progressIntervalId); 
            setProgressPercentage(100);
            const totalDuration = 10000; 
            const updateFrequency = 100; 
            const steps = totalDuration / updateFrequency;
            const decrementPerStep = 100 / steps;

            const newProgressInterval = setInterval(() => {
                setProgressPercentage(prev => {
                    const nextVal = prev - decrementPerStep;
                    if (nextVal <= 0) {
                        clearInterval(newProgressInterval);
                        return 0;
                    }
                    return nextVal;
                });
            }, updateFrequency);
            setProgressIntervalId(newProgressInterval);
        };

        const performFetchAction = () => {
            startProgressCountdown(); 
            if (initialFilters.selectedCarnetType === '') { 
                if (carnetValuesForCycling.length > 0) {
                    const carnetValueToFetch = carnetValuesForCycling[currentIndex];
                    const label = allCarnetTypesMap.get(carnetValueToFetch) || 
                                  (PREDEFINED_CARNET_TYPES.find(p => p.value === carnetValueToFetch)?.label || `TIPO ${carnetValueToFetch}`);
                    fetchStatsForDisplay(carnetValueToFetch, initialFilters.paymentStatuses, label);
                    currentIndex = (currentIndex + 1) % carnetValuesForCycling.length;
                } else {
                    setCarnetLabelForDisplay("NO HAY TIPOS DE CARNET DISPONIBLES");
                    setLoading(false);
                    if (playbackIntervalId) clearInterval(playbackIntervalId);
                    if (progressIntervalId) clearInterval(progressIntervalId); 
                }
            } else { 
                const labelForSingleType = allCarnetTypesMap.get(initialFilters.selectedCarnetType) ||
                                           (PREDEFINED_CARNET_TYPES.find(p => p.value === initialFilters.selectedCarnetType)?.label || `TIPO ${initialFilters.selectedCarnetType}`);
                fetchStatsForDisplay(initialFilters.selectedCarnetType, initialFilters.paymentStatuses, labelForSingleType);
            }
        };

        performFetchAction(); 
        const newPlaybackIntervalId = setInterval(performFetchAction, 10000);
        setPlaybackIntervalId(newPlaybackIntervalId);

        return () => {
            clearInterval(newPlaybackIntervalId);
            if (progressIntervalId) clearInterval(progressIntervalId);
            setPlaybackIntervalId(null);
            setProgressIntervalId(null);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialFilters, allCarnetTypesMap]); 


    // handleReturnAndStop is defined above useEffect for keydown

    return (

        <div className="addex" style={{ padding: '20px', textAlign: 'center', minHeight: '100vh', color: '#333'}}>
            {/* <div className="w-100 d-flex align-items-center" style={{paddingTop: '10px', paddingBottom: '10px'}}>
                <div style={{ width: '100%', margin: 'auto 20px ', height: '10px', backgroundColor: '#e9ecef', borderRadius: '5px', overflow: 'hidden',}}>
                    <div style={{ width: `${progressPercentage}%`, height: '100%', backgroundColor: '#28a745', transition: progressPercentage === 100 ? 'none' : 'width 0.1s linear' }}></div>
                </div>                
            </div> */}
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="w-100 d-flex align-items-center flex-column" style={{paddingTop: '10px', paddingBottom: '10px'}}>
                            {/* Button removed */}
                            <span className="count-addex">Cambio en: <b>{progressPercentage} </b>seg</span>
                            <div className="bar-progress-addex">
                                <div className="bar-progress-addex_pill" style={{ width: `${progressPercentage}%`, transition: progressPercentage === 100 ? 'none' : 'width 0.1s linear' }}></div>
                            </div>                
                        </div>

                    </div>
                </div>
            </div>

            <h2 className="title-main-addex">
                {carnetLabelForDisplay === 'CARGANDO...' && loading ? <Loader /> : carnetLabelForDisplay}
            </h2>

            {/* {loading && statisticsData.totalAttendees === '-' ? (
                <div style={{marginTop: '50px'}}><Loader size="large"/></div>
            ) : (
                <table style={{
                    width: '100%', margin: '0 auto',
                    fontSize: 'clamp(1rem, 3.5vw, 2rem)', borderCollapse: 'collapse',
                    boxShadow: '0 8px 25px rgba(0,0,0,0.1)', borderRadius: '8px', overflow: 'hidden'
                }}>
                    <thead style={{ backgroundColor: '#343434', color: 'white' }}>
                        <tr>
                            <th style={{ padding: '12px 18px', borderBottom: '1px solid #dee2e6', borderRight: '1px solid #474747' }}>Descripción</th>
                            <th style={{ padding: '12px 18px', borderBottom: '1px solid #dee2e6' }}>Cantidad</th>
                        </tr>
                    </thead>
                    <tbody>
                        {[
                            { desc: 'Número de Asistentes', val: statisticsData.totalAttendees, modes: ['full', 'attendees_impressions', 'attendees_kits', 'attendees_unprinted', 'attendees_undelivered_kits'] },
                            { desc: 'Carnets Impresos', val: statisticsData.printedCount, modes: ['full', 'attendees_impressions'] },
                            { desc: 'Carnets Faltantes de Imprimir', val: statisticsData.remainingToPrint, modes: ['full', 'attendees_impressions'] },
                            { desc: 'Kits Entregados', val: statisticsData.kitsDelivered, modes: ['full', 'attendees_kits'] },
                            { desc: 'Kits Faltantes de Entregar', val: statisticsData.remainingKits, modes: ['full', 'attendees_kits'] },
                        ]
                        .filter(item => item.modes.includes(currentDisplayMode))
                        .map((item, index) => (
                            <tr key={index} style={{ backgroundColor: index % 2 ? '#f8f9fa' : '#ffffff', borderBottom: '1px solid #dee2e6' }}>
                                <td style={{ padding: '12px 18px', textAlign: 'left', borderRight: '1px solid #dee2e6' }}>{item.desc}</td>
                                <td style={{ padding: '12px 18px', fontWeight: '600' }}>
                                    {loading && item.val === '-' ? <Loader size="small"/> : item.val}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                
            )} */}
            <div className="container-fluid">
                <div className="row mb-4">
                    <div className="col-md-9">
                        <div className="card p-4 h-100">
                        <Line
                            data={{
                                labels: currentDisplayMode === 'full'
                                ? [
                                    `Asistentes: [${statisticsData.totalAttendees}]`,
                                    `Impresos: [${statisticsData.printedCount}]`,
                                    `No Impresos: [${statisticsData.remainingToPrint}]`,
                                    ]
                                : currentDisplayMode === 'attendees_impressions'
                                ? [
                                    `Asistentes: [${statisticsData.totalAttendees}]`,
                                    `Impresos: [${statisticsData.printedCount}]`,
                                    `No Impresos: [${statisticsData.remainingToPrint}]`,
                                    ]
                                : [
                                    `Asistentes: [${statisticsData.totalAttendees}]`,
                                    `Impresos: [${statisticsData.printedCount}]`,
                                    `No Impresos: [${statisticsData.remainingToPrint}]`,
                                    ],
                                datasets: [
                                {
                                    label: 'Cantidad',
                                    data:
                                    currentDisplayMode === 'full'
                                        ? [
                                            Number(statisticsData.totalAttendees) || 0,
                                            Number(statisticsData.printedCount) || 0,
                                            Number(statisticsData.remainingToPrint) || 0,
                                        ]
                                        : currentDisplayMode === 'attendees_impressions'
                                        ? [
                                            Number(statisticsData.totalAttendees) || 0,
                                            Number(statisticsData.printedCount) || 0,
                                            Number(statisticsData.remainingToPrint) || 0,
                                        ]
                                        : [
                                            Number(statisticsData.totalAttendees) || 0,
                                            Number(statisticsData.printedCount) || 0,
                                            Number(statisticsData.remainingToPrint) || 0,
                                        ],
                                    fill: false,
                                    borderColor: 'rgba(0, 0, 0, 0.3)',
                                    backgroundColor: 'transparent',
                                    tension: 0.3, // suaviza la línea
                                    pointBackgroundColor: [
                                    'rgba(227, 33, 104, 1)',
                                    'rgba(2, 144, 179, 1)',
                                    'rgba(128, 186, 67, 1)',
                                    ],
                                    pointBorderColor: [
                                        'rgba(227, 33, 104, 1)',
                                        'rgba(2, 144, 179, 1)',
                                        'rgba(128, 186, 67, 1)',
                                        ],
                                    borderWidth: 2,
                                    pointRadius: 6,
                                     pointHoverRadius: 8,
                                },
                                ],
                            }}
                            options={{
                                responsive: true,
                                plugins: {
                                legend: {
                                    position: 'top',
                                    labels: {
                                    font: {
                                        size: 14,
                                    },
                                    },
                                },
                                tooltip: {
                                    callbacks: {
                                    label: (context) =>
                                        `${context.label}: ${context.formattedValue}`,
                                    },
                                },
                                },
                                scales: {
                                y: {
                                    beginAtZero: true,
                                    ticks: {
                                    precision: 0,
                                    },
                                },
                                x: {
                                    ticks: {
                                    font: {
                                        size: 12,
                                    },
                                    },
                                },
                                },
                            }}
                            />                     
                        </div>
                
                    </div>
                    <div className="col-md-3">
                        <div className="row">
                            <div className="col-12 mb-4">
                                <div className="card-addex-num bg-one">
                                    <div className="">
                                        <strong className="data-addex one bg-one">
                                            <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-user"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" /><path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" /></svg>
                                            {statisticsData.totalAttendees}
                                        </strong>
                                        <h3 className="title-addex one">Asistentes</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 mb-4">
                                <div className="card-addex-num bg-two">
                                    <div className="">
                                        <strong className="data-addex two"> 
                                            <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-printer"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" /><path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" /><path d="M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z" /></svg>
                                            {statisticsData.printedCount}
                                        </strong>
                                        <h3 className="title-addex two">Impresos</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="card-addex-num bg-three">
                                    <div className="">
                                        <strong className="data-addex three"> 
                                            <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-printer"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" /><path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" /><path d="M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z" /></svg>
                                            {statisticsData.remainingToPrint}
                                        </strong>
                                        <h3 className="title-addex three">No impresos</h3>
                                    </div>
                                </div>
                            </div>
{/* 
                            <div className="col-md-4">
                                <div className="card py-3">
                                    <h3 className="title-addex">Asistentes</h3>
                                    <strong className="data-addex one">{statisticsData.totalAttendees}</strong>
                                </div>
                            </div>
                            
                            {(currentDisplayMode === 'full' || currentDisplayMode === 'attendees_impressions') && (
                                <>
                                    <div className="col-md-4">
                                        <div className="card py-3">
                                            <h3 className="title-addex">Impresos</h3>
                                            <strong className="data-addex two">{statisticsData.printedCount}</strong>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="card py-3">
                                            <h3 className="title-addex">No Impresos</h3>
                                            <strong className="data-addex three">{statisticsData.remainingToPrint}</strong>
                                        </div>
                                    </div>
                                </>
                            )}
                            
                            {(currentDisplayMode === 'full' || currentDisplayMode === 'attendees_kits') && (
                                <>
                                    <div className="col-md-4">
                                        <div className="card py-3">
                                            <h3 className="title-addex">Kits Entregados</h3>
                                            <strong className="data-addex four">{statisticsData.kitsDelivered}</strong>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="card py-3">
                                            <h3 className="title-addex">Kits Faltantes</h3>
                                            <strong className="data-addex five">{statisticsData.remainingKits}</strong>
                                        </div>
                                    </div>
                                </>
                            )} */}
                        </div>
                    </div>
                </div>
            </div>
         
           


        </div>
    );
};

export default EstadisticaReproduccion;


